if (!window.__cartUpgradeBound) {
  window.__cartUpgradeBound = true;

  let themeModulesPromise = null;

  function getThemeModules() {
    if (!themeModulesPromise) {
      themeModulesPromise = Promise.all([
        import('@theme/section-renderer').catch(() => null),
        import('@shopify/events').catch(() => null),
      ]).then(([sectionRendererMod, eventsMod]) => ({
        morphSection: sectionRendererMod?.morphSection,
        sectionRenderer: sectionRendererMod?.sectionRenderer,
        CartLinesUpdateEvent: eventsMod?.CartLinesUpdateEvent,
      }));
    }
    return themeModulesPromise;
  }

  function collectSectionIds() {
    const ids = new Set(['cart-drawer-section']);
    document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
      if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids).join(',');
  }

  async function postCart(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });

    let data;
    try {
      data = await response.json();
    } catch {
      throw new Error('Cart returned non-JSON (HTTP ' + response.status + ')');
    }

    if (!response.ok) {
      throw new Error(data?.description || data?.message || 'Cart request failed (HTTP ' + response.status + ')');
    }
    return data;
  }

  async function refreshCartUi(cart) {
    const sections = cart.sections || {};
    const mods = await getThemeModules();
    let updated = false;

    for (const [sectionId, html] of Object.entries(sections)) {
      const node = document.getElementById('shopify-section-' + sectionId);
      if (!html || !node) continue;

      const isDrawer = !!document.querySelector(
        `cart-items-component[data-drawer][data-section-id="${sectionId}"]`
      );

      try {
        if (mods.morphSection) {
          mods.sectionRenderer?.abortRender?.(sectionId);
          await mods.morphSection(sectionId, html, { mode: isDrawer ? 'hydration' : 'full' });
        } else {
          node.outerHTML = html;
        }
        updated = true;
      } catch (err) {
        console.warn('[cart-upgrade] Section update failed for ' + sectionId, err);
        try {
          node.outerHTML = html;
          updated = true;
        } catch {
          /* ignore */
        }
      }
    }

    if (mods.CartLinesUpdateEvent) {
      try {
        const deferred = mods.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(
          new mods.CartLinesUpdateEvent({ action: 'update', context: 'cart', promise: deferred.promise })
        );
        deferred.resolve({
          cart: mods.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            sections,
            items: cart.items,
            itemCount: cart.item_count,
            source: 'cart-upgrade',
            didError: false,
          },
        });
      } catch (err) {
        console.warn('[cart-upgrade] Cart icon sync skipped', err);
      }
    }

    return updated;
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.cart-upgrade__btn');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const addVariantId = parseInt(btn.dataset.addVariantId, 10);
    const bookLineKey = btn.dataset.bookLineKey;
    if (!addVariantId || !bookLineKey) return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const item = { id: addVariantId, quantity: 1 };
      if (btn.dataset.cartUpsellAction === 'audiobook') {
        item.properties = { _from_ebook_upsell: '1' };
      }
      await postCart('/cart/add.js', { items: [item] });

      const finalCart = await postCart('/cart/change.js', {
        id: bookLineKey,
        quantity: 0,
        sections: collectSectionIds(),
        sections_url: window.location.pathname,
      });

      const uiUpdated = await refreshCartUi(finalCart);
      if (!uiUpdated) {
        try {
          sessionStorage.setItem('theme-drawer-open', 'cart-drawer');
        } catch {
          /* ignore */
        }
        window.location.reload();
      }
    } catch (err) {
      console.error('[cart-upgrade]', err);
      alert('Could not update cart: ' + (err instanceof Error ? err.message : 'Unknown error'));
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });
}